import { IconButton, TextField } from '@material-ui/core';
import { StyledComponentProps, withStyles } from '@material-ui/core/styles';
import Delete from '@material-ui/icons/Delete';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ITemplateItem } from '../main/entities';
import { mg } from '../mg/mg';
import { IDataviewStore } from '../stores/DataviewStore';
import { getOmnistore } from '../stores/Omnistore';
import { AmountToOrderDialog } from './AmountToOrderDialog';

const styles = ({
});

type IOnEdit = (entity: {[s: string]: any}, changes: {[s: string]: any}) => void

interface IAmountToOrderProps {
	entity: ITemplateItem
	state: IDataviewStore
	onEdit?: IOnEdit
}

@observer export class _AmountToOrder extends React.Component<IAmountToOrderProps & StyledComponentProps> {
	@computed get _column() {
		return this.props.state.columnByName('amountToOrder');
	}

	@observable _value: null | number = null

	@observable _hasError = false

	@action _onChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
		event.target.focus();
		const {entity} = this.props;
		const v0 = event.target.value;
		const v1 = this._column.preclean(v0);
		this._value = v1;
    this._onBlur();
	}

	@action _onClick = (event: React.MouseEvent) => {
		event.preventDefault();
		event.stopPropagation();
	}

	_onFocus = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => event.target.select()

	@action _onBlur = () => {
		const {entity, onEdit} = this.props;
		const v0 = this._value;
		if (v0 === null) return;

		const v2 = this._column.sanitize(v0, entity);
		this._hasError = v0 !== v2;
		if (this._hasError) return;

		if (mg.checkPresent(onEdit, 'onEdit in _onBlur')) onEdit(entity, {[this._column.fieldName]: v0});
		this._value = null;
	}

	@action _onDelete = (event: React.ChangeEvent<EventTarget>) => {
		event.preventDefault();
		event.stopPropagation();
		const {entity} = this.props;
		getOmnistore().multirepo.templateItemRepo(entity.templateId).upserter.delete(entity);
	}

	@action _onDialogClose = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
		event.preventDefault();
		event.stopPropagation();
		this._value = +event.currentTarget.name;
		this._onBlur();
	}

	render() {
		const {entity, state} = this.props;
		const value = this._value!==null ? this._value : this._column.formatForView(entity);
		const step = entity.amountStep || 1;
		const inputProps = {
			name: 'amountToOrder',
			type: 'number',
			min: 0,
			step,
		};
		return <React.Fragment>
			{
				state.disabling && (entity as any)[state.disabling]
					?
					<IconButton style={{color: 'inherit'}} onClick={this._onDelete}>{<Delete/>}</IconButton>
					:
					<TextField
						inputProps={inputProps}
						onChange={this._onChange}
						onFocus={this._onFocus}
						onBlur={this._onBlur}
					//	onMouseOut={this._onBlur}
						onClick={this._onClick}
						style={{textAlign: 'right', width: '80%'}}
						value={''+value}
					/>
			}
			{
				!this._hasError || this._value===null ? null :
					<AmountToOrderDialog value={this._value} step={step} onClose={this._onDialogClose}/>
			}
		</React.Fragment>;
	}
}

export const AmountToOrder = withStyles(styles)(_AmountToOrder);
